import { createContext, useState } from 'react';
import { LayoutContextState, LayoutContextValue, LayoutProviderProps } from './layout-context.types';

export const defaultState: LayoutContextState = {
  isOrderDetailsMobileShow: false
}

export const LayoutContext = createContext<LayoutContextValue>({ layoutState: defaultState, setLayoutState: () => { } });

export const StepProvider: React.FC<LayoutProviderProps> = ({ children }) => {
  const [layoutState, setStepState] = useState<LayoutContextState>({ ...defaultState });

  const setStepStateContext = (state: Partial<LayoutContextState>) => {
    setStepState(prevState => ({
      ...prevState,
      ...state
    }))
  }

  return (
    <LayoutContext.Provider value={{ layoutState, setLayoutState: setStepStateContext }}>
      {children}
    </LayoutContext.Provider>
  )
}
